import { Currency } from '@models/Currency'

export type TierKey = keyof Tier

export interface Tier {
  gold: [number, number]
  platinum: [number, number]
  platinumF: [number, number]
  sapphire: [number, number]
  sapphireF: [number, number]
  emerald: [number, number]
  emeraldF: [number, number]
  diamond: [number, number]
  diamondF: [number, number]
}

export interface CountryData {
  country: Country
  region: Region
  currency: Currency
  ratioPVBV: number
  tiers: Tier
  bronzeFoundationMultiplier: number
  bronzeBuilderMultiplier: number
  bronzeBuilderConsistency: {
    multiplier6x: number
    multiplier12x: number
  }
  performanceBonus: {
    percent3: number
    percent6: number
    percent9: number
    percent12: number
    percent15: number
    percent18: number
    percent21: number
  }
  // frontlineGrowthIncentive* fields are consumed by Leadership Plus (the FGI
  // calculation itself was retired with the 2024 version, the data columns live on)
  frontlineGrowthIncentive: {
    multiplierMaintain: number
    multiplier1to5: number
    multiplier6plus: number
  }
  newPerformancePlusMonthlyPv: number
  frontlineGrowthIncentiveAnnualVolume: number
  frontlineGrowthIncentiveAmountCap: number
  frontlineGrowthIncentiveRubyPVRequirement: number
  // Path to Bronze monthly amounts, cumulative per qualifying leg count
  pathToBronze: {
    legs3: number
    legs4: number
    legs5: number
    legs6: number
  }
}

export enum Region {
  WE = 'Western Europe',
  CE = 'Central Europe',
  EE = 'Eastern Europe',
  SA = 'South Africa',
  ANZ = 'Australi & New Zealand'
}

export enum Country {
  AT = 'Austria',
  BE = 'Belgium',
  BG = 'Bulgaria',
  HR = 'Croatia',
  CZ = 'Czech Republic',
  DK = 'Denmark',
  EE = 'Estonia',
  FI = 'Finland',
  FR = 'France',
  DE = 'Germany',
  GR = 'Greece',
  HU = 'Hungary',
  IE = 'Ireland',
  IT = 'Italy',
  LT = 'Lithuania',
  LV = 'Latvia',
  NL = 'Netherlands',
  NO = 'Norway',
  PL = 'Poland',
  PT = 'Portugal',
  RO = 'Romania',
  SK = 'Slovak Republic',
  SI = 'Slovenia',
  ZA = 'South Africa',
  ES = 'Spain',
  SE = 'Sweden',
  CH = 'Switzerland',
  TR = 'Turkey',
  UA = 'Ukraine',
  GB = 'United Kingdom',
  NZ = 'New Zealand',
  AU = 'Australia'
}
